/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { useSelector } from "react-redux";
import get from "lodash/get";

import VideoIcon from "../../atoms/icons/video-icon";
import CardImage from "../../atoms/cardimage";
import { getCollection } from "../../helper/api";
import CarouselSidebar from "../../atoms/carousel-sidebar";

import "./sidebar-content.m.css";

const SideBarContent = ({ title, speed, type }) => {
  const storyReducer = useSelector((state) => get(state, ["storyReducer"], []));
  const makeSecondaryApiCalls = storyReducer.makeSecondaryApiCalls;
  const isMobile = storyReducer.isMobile;
  const delay = storyReducer.delay;

  const [isVisible, setIsVisible] = useState(false);
  const [items, setItems] = useState([]);

  const getItems = async () => {
    const url = type === "photo" ? "photo-gallery-pv" : type === "cinema" ? "entertainment-news" : "story-page-video";
    try {
      getCollection(url, 0, 5).then((stories) => setItems(stories));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (makeSecondaryApiCalls) {
      setTimeout(() => getItems(), delay);
      setTimeout(() => setIsVisible(true), delay + 500);
    }
  }, [makeSecondaryApiCalls]);

  const getItemCard = (story, index) => {
    return (
      <Link href={`/${story.slug}`} key={index}>
        <div styleName="content-card">
          <CardImage story={story} aspectRatio={[16, 9]} imageType="image16x9" widths={[360]} />
          {story["story-template"] === "video" && (
            <div styleName="video-icon">
              <VideoIcon width="40" height="40" />
            </div>
          )}
        </div>
      </Link>
    );
  };

  return isVisible ? (
    <div styleName={type ? "wrapper wrapper-photo" : "wrapper"}>
      <div styleName="title">{title}</div>
      <div styleName="content-element">
        <CarouselSidebar
          options={{
            autoplay: true,
            speed: 500,
            dots: true
          }}
        >
          {items.length > 0 && items.slice(0, 5).map((item, index) => getItemCard(item, index))}
        </CarouselSidebar>
      </div>
    </div>
  ) : null;
};

export default SideBarContent;
